<template>
    
    <div class="clock">
        <span>{{localTime}}</span>
        <span>Next Week Begins in <span :style="{'color': color}">{{weekStarts}}</span></span>
    </div>

</template>

<script>
    
    import moment from 'moment';
    require('jquery-countdown');


    export default {
        data() {
            return {
                localTime: null,
                weekStarts: null,
                color:null
            }
        },
        mounted() {
            var self = this;

            self.getTime();


            window.setInterval(function(){
                self.getTime();
            },1000);
        },
        methods: {
            getTime() {
                var self = this;
                if (!this.$store.getters.currentTerm) return;

                this.localTime = moment().format('MMM D, YYYY h:mm a');

                const monday = moment().startOf('isoWeek').add(1, 'week');

                var countDownDate = monday.toDate().getTime();

                var now = new Date().getTime();
                var timeLeft = countDownDate - now;

                var days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
                var hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

                let weekStarts = ('00' + hours).slice(-2) + ':' + ('00' + minutes).slice(-2);
                if (days > 0) {
                    weekStarts = days + ' days ' + weekStarts;
                }

                if (hours < 1) {
                    weekStarts = weekStarts + ':'
                    + ('00' + seconds).slice(-2);
                }

                this.weekStarts = weekStarts;

                const secondsUntilStart = timeLeft / 1000;

                if (secondsUntilStart < 21600) {
                    this.color = 'red';
                } else if (secondsUntilStart < 86400) {
                    this.color = 'yellow';
                } else {
                    this.color = '#3feb9b';
                }

                // var now = moment();
                // var endOfWeek;

                // let weekStartsOn = moment.utc(this.$store.getters.currentTerm.startDate).isoWeekday();
                // const today = moment.utc().isoWeekday();
                
                // let startOfWeek = null;
                
                // if (today === 7) { 
                //    startOfWeek = moment.utc().startOf('day').add(1, 'weeks').isoWeekday(weekStartsOn);    
                // } else {
                //     startOfWeek = moment.utc().startOf('day').add(1, 'weeks').isoWeekday(weekStartsOn)
                // }

                // var offset = moment.tz.zone('America/Vancouver').offset(moment.utc()) / 60
                // startOfWeek = startOfWeek.add(offset, 'hours');

                // var countdown = moment(startOfWeek).diff(moment());


                // countdown = moment.duration(countdown);
                // console.log(startOfWeek)

                // let seconds = countdown.seconds();
              
                // let weekStarts = ('00' + countdown.hours()).slice(-2) + ":" 
                // + ('00' + countdown.minutes()).slice(-2);

                // if (countdown.days() > 0) {
                //     weekStarts = countdown.days() + ' days ' + weekStarts;
                // }

                // if (countdown.hours() < 1) {
                //     weekStarts = weekStarts + ':'
                //     + ('00' + seconds).slice(-2);
                // }

                // this.weekStarts = weekStarts;
                
                // let secondsUntilStart = parseInt(countdown._milliseconds / 1000);
               


            }
        }
    }
</script>

<style lang="scss" scoped>

.clock {
    text-align:center;
    margin-bottom:2rem;
    & > span {
        display:block;
    }
}
</style>


// WEBPACK FOOTER //
// Clock.vue?1fa274c0